"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3641],{

/***/ 313641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "JsonPageBuilderWidget": function() { return /* reexport */ JsonPageBuilderWidget; },
  "JsonPageBuilderWidgetWrapper": function() { return /* reexport */ JsonPageBuilderWidgetWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/@dotpe/kui/index.js
var kui = __webpack_require__(615089);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/widgetDnD.module.scss
var widgetDnD_module = __webpack_require__(260373);
var widgetDnD_module_default = /*#__PURE__*/__webpack_require__.n(widgetDnD_module);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/CreateHTML.tsx + 6 modules
var CreateHTML = __webpack_require__(714564);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(326706);
// EXTERNAL MODULE: ./src/components/DesignSystem/index.js + 1 modules
var DesignSystem = __webpack_require__(506449);
;// CONCATENATED MODULE: ./src/components/DesignSystem/JsonPageBuilderWidget/JsonPageBuilderWidget.tsx







// eslint-disable-next-line
var JsonPageBuilderWidgetWrapper = function() {
    var jsonTree = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return state.jsonWidgetsReducer.widgets;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "page-builder-view",
        className: (widgetDnD_module_default()).builderPage,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateHTML/* CreateHTML */.IU, {
            jsonTree: jsonTree
        })
    });
};
// const areEqual = (prevProps: JsonPageWidgetProps, nextProps: JsonPageWidgetProps) => {
//   if (prevProps.widget_id === nextProps.widget_id) {
//     return true;
//   }
//   return false;
// };
// export const JsonPageBuilderWidget = React.memo(JsonPageBuilderWidgetWrapper, areEqual);
var JsonPageBuilderWidget = JsonPageBuilderWidgetWrapper;

;// CONCATENATED MODULE: ./src/components/DesignSystem/JsonPageBuilderWidget/index.tsx



/***/ })

}]);